import { init, map } from './map.js';
import { accordion, getParameterByName, diffDates } from './module/module.js';
import { setRoomsStorage } from './model/room-load.js';
import { setModuleLanguage } from "./module/module-language.js";
// import { startScenariosHotel } from './const.js';
import { changeURLDate, tabsBookingForm } from './booking-form.js';
import {roomsList} from "./module/rooms-list.js";

import {PriceLoad as PriceLoadController} from './controller/price-load.js';

let isCheck = false;

window.setTlPrices = () => {
    const priceLoadController = new PriceLoadController();

    if (priceLoadController.isLoadNeeded()) {
        priceLoadController.load()
            .then(() => {
                setModuleLanguage();
                accordion();
                setRoomsStorage();
                // startScenariosHotel();
                tabsBookingForm();
                ymaps.ready(init);
                 isCheck = true;
            });
    } else {
        // const prices = priceLoadController.getFromCache();
        setModuleLanguage();
        accordion();
        setRoomsStorage();
        // startScenariosHotel();
        tabsBookingForm();
        ymaps.ready(init);
         isCheck = true;
    }
};

document.addEventListener('DOMContentLoaded', () => {
    window.setTlPrices();
});


window.mapBookingApart = (roomsFb, arrival, departure, providerId) => {
    function checkFunctionStatus() {
        if (isCheck) {

            map.balloon.close();

            roomsList(roomsFb, providerId);

            if (getParameterByName('date')) {
                let date = "date";
                let regexDate = new RegExp(/date=[A-Za-z0-9_-]+/g);
                changeURLDate(date, regexDate, arrival)

                let nights = diffDates(new Date(departure),  new Date(arrival));
                let nightsUrl = "nights";
                let regexNights = new RegExp(/nights=\d+/g);
                changeURLDate(nightsUrl, regexNights, nights);
            }

        } else {
            setTimeout(checkFunctionStatus, 300);
        }
    }
    checkFunctionStatus();
}

